import React from "react";
import { FileText, Loader2, MessageSquare } from "lucide-react";
import moment from "moment";
import "./index.scss";

const ChatLibraryPanel = ({
  sessions,
  loading,
  openConversation,
  activeSessionId,
}) => {
  return (
    <div className="chat-library-panel">
      <div className="cl-header">
        <div className="header-top">
          <h4>Chat History</h4>
          <span>
            {sessions.length} {sessions.length === 1 ? "session" : "sessions"}
          </span>
        </div>
        <p>All your conversations</p>
      </div>

      <div className="cl-body">
        {loading ? (
          <div className="loading-state">
            <Loader2 size={32} className="animate-spin" />
            <p>Loading sessions...</p>
          </div>
        ) : sessions.length === 0 ? (
          <div className="empty-state">
            <MessageSquare size={48} style={{ color: "#d1d5db" }} />
            <p>No conversations yet</p>
            <p>Upload a CSV to start chatting</p>
          </div>
        ) : (
          <div className="sessions-list">
            {sessions?.filter((session) => session?.thread_id)?.map((session) => {
              const isActive = session.session_id === activeSessionId;

              return (
                <div
                  key={session.session_id}
                  className={`session-item ${isActive ? "active" : ""}`}
                  onClick={() => openConversation(session.session_id)}
                >
                  <div className="file-icon">
                    <FileText size={16} />
                  </div>

                  <div className="details">
                    <div
                      className={`filename ${isActive ? "active-name" : ""}`}
                      title={session.filename}
                    >
                      {session.filename || "Untitled"}
                    </div>

                    <div className="meta">
                      <span>
                        {session.created_at
                          ? moment.utc(session.updated_at).local().fromNow()
                          : "Recently"}
                      </span>

                      {session.message_count > 0 && (
                        <>
                          <span>•</span>
                          <span>{session.message_count} messages</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatLibraryPanel;
